import { Injectable }    from '@angular/core';

import { Admin } from '../../classes/admin';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

@Injectable()
export class AdminService extends UserService {

  constructor(
    protected requestService: RequestService,
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'admins';
  };

  protected getOneUserUrl(): string {

    return 'admin';
  };

  protected parseObject(obj: any): Admin {

    return obj as Admin;
  };

  protected parseArray(objs: any): Admin[] {

    return objs as Admin[];
  };

  getPermissions(): Promise<any>{
    return this.requestService.makeRequest({
      urlKey: 'permissions'
    })
    .then((res: any) => this.parseObject(res.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/admins/admin.service.ts